import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { logout } from '../../auth/auth';
import LogoutConfirmModal from "../LogoutConfirmModal/LogoutConfirmModal";
import styles from "./HeaderMobile.module.scss";
import backArrow from "../../assets/hospitalReservation/mobileBack.png";
import logo from "../../assets/logo.png";
import globe from "../../assets/hospitalReservation/globe.png";
import logoutIcon from "../../assets/hospitalReservation/dots.png";

const HeaderMobile: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [isLanguageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  const [isLogoutDropdownOpen, setLogoutDropdownOpen] = useState(false);
  const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);
  
  const showBackArrow = location.pathname !== "/";

  function handleLanguageChange(langCode: string) {
    i18n.changeLanguage(langCode);
    localStorage.setItem("selectedLanguage", langCode);
    setLanguageDropdownOpen(false);
  }
  
  function confirmLogout() {
    logout();
    localStorage.removeItem("token");
    sessionStorage.clear();
    navigate("/login", { replace: true });
  }

  return (
    <header className={styles.headerMobile}>
      <div className={styles.leftIconsContainer}>
        <div className={styles.languageContainer}>
          <img
            src={globe}
            alt="Language Selector"
            className={styles.globeIcon}
            onClick={() => setLanguageDropdownOpen(!isLanguageDropdownOpen)}
          />
          {isLanguageDropdownOpen && (
            <ul className={styles.languageDropdown}>
              <li onClick={() => handleLanguageChange("en")}>English</li>
              <li onClick={() => handleLanguageChange("zh")}>中文</li>
              <li onClick={() => handleLanguageChange("ja")}>日本語</li>
              <li onClick={() => handleLanguageChange("ar")}>العربية</li>
            </ul>
          )}
        </div>
      </div>

      <img
        src={logo}
        alt="Logo"
        className={styles.logo}
        onClick={() => navigate("/")}
      />

      <div className={styles.rightIconsContainer}>
        <div className={styles.logoutContainer}>
          <img
            src={logoutIcon}
            alt="Logout"
            className={styles.logoutIcon}
            onClick={() => setLogoutDropdownOpen(!isLogoutDropdownOpen)}
          />
          {isLogoutDropdownOpen && (
            <ul className={styles.logoutDropdown}>
              <li onClick={() => setLogoutModalOpen(true)}>
                {t('logoutConfirm.logout')}
              </li>
            </ul>
          )}
        </div>
      </div>

      <LogoutConfirmModal
        isOpen={isLogoutModalOpen}
        onClose={() => setLogoutModalOpen(false)}
        onConfirm={confirmLogout}
      />
    </header>
  );
};

export default HeaderMobile;
